<template>
  <v-date-picker
    v-bind="$attrs"
    :title="$bct(title)"
  >
    <template
      v-for="(_, name) in $slots"
      #[name]="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData || {}"
      />
    </template>
  </v-date-picker>
</template>

<script setup>
const $bct = inject('translator');

defineProps({
  title: {
    type: String,
    default: 'Select date',
  },
});
</script>
